










































import { Vue, Component, Prop } from 'vue-property-decorator';

import TwismLogoIcon from '@/components/icons/TwismLogo.vue';
import CloseModalIcon from '@/components/icons/CloseModal.vue';

import { BusinessOnboardingLink } from '@/models/business-onboarding';
import { isExternalOauthSessionOnline } from '@/router/router-utils';

@Component({
  components: {
    TwismLogoIcon,
    CloseModalIcon
  }
})
export default class BaseLayout extends Vue {
  @Prop({ default: false }) hideIlustraOnMobile?: boolean;
  @Prop({ default: 'light' }) logoTheme?: 'dark' | 'light';
  @Prop({ default: true }) showNavLinks?: boolean;
  @Prop({ default: true }) scrollRightCol?: boolean;
  @Prop({ default: false }) removeMarginNav?: boolean;

  get managerCredentials() {
    return this.$store.getters['manager/getExtraInfo'];
  }

  get links() {
    return this.$store.getters[
      'businessOnboarding/getNavLinks'
    ] as BusinessOnboardingLink[];
  }

  get transformedLinks() {
    const activeIndex = this.links.findIndex(link =>
      link.routes.includes(this.$route.name || '')
    );

    return this.links.map((link, linkIndex) => {
      const routesAmount = link.routes.length;
      const internalActiveIndex = link.routes.findIndex(
        rouName => rouName == this.$route.name
      );
      const fraction = 100 / routesAmount;

      const isPrevLink = linkIndex < activeIndex;

      return {
        ...link,
        activePercentage: isPrevLink
          ? 100
          : (internalActiveIndex * 100) / routesAmount + fraction
      };
    });
  }

  get business() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get isLogged() {
    return (
      !!this.managerCredentials || this.$store.getters['manager/isImpersonated']
    );
  }

  get showCloseBtn() {
    return (
      !!this.business && !!this.isLogged && !isExternalOauthSessionOnline()
    );
  }
}
